import axios from 'axios';
import store from './redux/store/store';
import { toastr } from 'react-redux-toastr';
import { REDIRECT_TO_FORBIDDEN } from './constants/systemConstants';

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.code === 403) {
      toastr.warning(response.data.message);
      return store.dispatch({ 
        type: REDIRECT_TO_FORBIDDEN
      });
    }
    if (response.data.code === 401) {
      toastr.warning('Tài khoản này đang được đăng nhập ở 1 nơi khác. Vui lòng đăng nhập lại');
    }
    return response;
  }, 
  (error) => {
    return Promise.reject(error);
  }
);

export { axiosInstance };
